export const VisibilityIcon = () => (
  <svg
    className="security-icon"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 12C5 7.5 8.5 5 12 5C15.5 5 19 7.5 21 12C19 16.5 15.5 19 12 19C8.5 19 5 16.5 3 12Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M4 4L20 20"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
